import React, { useState } from "react";
import InternalWorkOrderPickerModal from "../../modals/InternalWorkOrderPickerModal";
import BulkAddToInternalWorkOrderProgressModal from "./BulkAddToInternalWorkOrderProgressModal";

export default function BulkAddToInternalWorkOrderModal({
  selectedIds,
  projectId,
  onClose,
  onComplete,
}) {
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);

  const handleSelect = workOrder => {
    setSelectedWorkOrder(workOrder);
  };

  const handleProgressComplete = () => {
    onComplete();
  };

  if (!selectedWorkOrder) {
    return (
      <InternalWorkOrderPickerModal
        projectId={projectId}
        onClose={onClose}
        onSelect={workOrder => handleSelect(workOrder)}
      />
    );
  }

  return (
    <BulkAddToInternalWorkOrderProgressModal
      selectedIds={selectedIds}
      internalWorkOrderId={selectedWorkOrder.id}
      selectedWorkOrder={selectedWorkOrder}
      onClose={onClose}
      onComplete={handleProgressComplete}
    />
  );
}
